export enum RenewableEnergyEnum {
    Wind = -1, // RSX_Eolien
    Photovoltaic = -2, // RSX_Photovoltaïque
    Hydraulic = -3, // RSX_Hydraulique
    SolarThermal = -4, // RSX_SolaireThermique
    Geothermal = -5, // RSX_Géothermie
    Biomass = -6 // RSX_Biomasse
}
